module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "base_line"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon_line"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Enter veri')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/Verfication Code.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tips",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('t1215_Multi_factor_ON').replace('$1', _vm.routeData.user_name))
    }
  }), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "placement": "top-start",
      "disabled": !_vm.isErrorCode,
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_vm._v(_vm._s(_vm.$t('errtip3')))]), _vm._v(" "), _c('el-input', {
    class: {
      'alert_border': _vm.isErrorCode
    },
    attrs: {
      "placeholder": _vm.$t('Entercode')
    },
    model: {
      value: (_vm.mfa_seccode),
      callback: function($$v) {
        _vm.mfa_seccode = $$v
      },
      expression: "mfa_seccode"
    }
  }, [_c('el-button', {
    staticClass: "login",
    on: {
      "click": function($event) {
        _vm.getCode()
      }
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.codeText))])], 1)], 1), _vm._v(" "), _c('button', {
    staticClass: "register",
    on: {
      "click": _vm.next
    }
  }, [_vm._v(_vm._s(_vm.$t('Next')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-275ce910"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/verificationCode.vue
// module id = 1438
// module chunks = 7